<script module lang="ts">
	import { writable, type Writable } from 'svelte/store';

	export interface AccordionCtxType {
		selected?: Writable<object>;
	}
</script>

<script lang="ts">
	import { setContext } from 'svelte';

	interface Props {
		title?: string;
		children: import('svelte').Snippet;
		multiple?: boolean;
		class?: string;
	}

	let { multiple = false, children, ...rest }: Props = $props();

	// `multiple` is a configuration prop set once at mount; the context shape is fixed for the lifetime of the component.

	// svelte-ignore state_referenced_locally
	const ctx: AccordionCtxType = {
		selected: multiple ? undefined : writable()
	};

	setContext<AccordionCtxType>('accordion_ctx', ctx);
</script>

<div {...rest} class={rest?.class}>
	{@render children?.()}
</div>
